export default {
  state: {
    providers: {},
    puzzles: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/PuzzlesStore.js